module.exports = function (element) {
    let t = 0;
    let ref;

    function refresh(node, more) {
        t++;
        if (t > 50) {
            window.clearInterval(ref);
            more.show();
        }

        $.post('/last/', function (data) {
            for (i = 0; i < data.result.length; i++) {
                block = node.find(".wallpapers__item").eq(i);
                block.find('.wallpapers__item__img').attr("src", data.result[i].img).on('load', {
                    item: data.result[i],
                    block: block
                }, function (event) {
                    event.data.block.find('a:eq(0)').attr("href", event.data.item.url);
                    if (event.data.item.time === 0)
                        event.data.block.find('.wallpapers__item__user_block__user').text('сейчас');
                    else
                        event.data.block.find('.wallpapers__item__user_block__user').text(event.data.item.time + ' сек. назад');
                });
            }
        }, 'json');
    }

    function lastBlock(el) {
        var node = $(el);
        var more = $(el).find('.js-last-more');

        ref = window.setInterval(function () {
            refresh(node, more)
        }, 5000);

        more.on({
            click: function () {
                refresh(node, more)
            }
        })
    }

    if (!element) {
        throw new Error('Element undefined');
    }

    lastBlock(element);
};
